import React from 'react';
import PropTypes from 'prop-types';

import './ShareIcon.scss';
import { constructCn } from '../../../utilities/helperFunctions';

const ShareIcon = ({ className, isActive }) => {
    const cn = constructCn(
        'component-Icons-ShareIcon',
        className,
        isActive && 'active',
        !isActive && 'inactive'
    );
    return (
        <svg
            className={cn}
            width="30px"
            height="40px"
            viewBox="0 0 30 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g
                id="React/share-click"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g id="set-1-share" transform="translate(0.000000, 10.000000)">
                    <circle id="circle" cx="15" cy="15" r="15" />
                    <path
                        id="arrow-component"
                        d="M3,24 C3,24 3.88789595,9.93313116 18.0132903,11.5286199 L18.0479091,6.41461534 C18.0501516,6.08277321 18.4540847,5.88653285 18.7549322,6.07101806 L29.7982694,12.8438479 C30.0404611,12.9924253 30.0696838,13.3086581 29.8581866,13.4923725 L19.1137346,22.8260908 C18.8280242,23.0742337 18.3567455,22.8947589 18.3468644,22.5341391 L18.2001198,17.1610073 C18.2001198,17.1610073 9.43756096,16.1180749 3,24"
                    />
                </g>
            </g>
        </svg>
    );
};

ShareIcon.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
};

ShareIcon.defaultProps = {
    className: '',
    isActive: false,
};

ShareIcon.displayName = 'ShareIcon';

export default React.memo(ShareIcon);
